import React from "react";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import CssBaseline from "@mui/material/CssBaseline";
import SaveIcon from "@mui/icons-material/Save";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Select from "@mui/material/Select";
import Typography from "@mui/material/Typography";
import FormHelperText from "@mui/material/FormHelperText";
import { connect } from "react-redux";
import CurrencyInput from "../common/CurrencyInput";
import * as companyApi from "../../api/companyApi";
import * as premiumUtils from "./PremiumUtils";
import { FormControl, InputAdornment } from "@mui/material";


class NewPremiumUser extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {},
      member: {},
      premium: {},
      allPremiums: [],
      prizeId: -1,
      ownerships: [],
      ownership: {},
      membersbyOrg: [],
      error: {},
      membership: props.type,
      tffCodes: [],
      selectedTffCode: {},
      isActive: (status) => status === "Aktiv",
    };
    this.currencyInputRef = React.createRef();
  }

  async componentDidMount() {
    try {
      const user = this.props.signedinuser;

      if (user) {
        this.setState({ user });
        const company = await companyApi.getCompany(user.companyId);
        if (company) {
          const mainCode = company.codeTFF.find((c) => c.mainCode);

          this.setState({
            status: company[this.state.membership.toLowerCase() + "StatusName"],
            tffCodes: company.codeTFF,
            premium: {
              ...this.state.premium,
              reportedCodeTff: this.state.membership === "TFF"
                ? (mainCode?.code || (company.codeTFF[0]?.code || ""))
                : undefined,
            }
          });
        }
        this.fetchMembersByOrg();
      }
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      const membership = this.props.type;
      this.setState(
        {
          membership,
          premium: {
            ...this.state.premium,
            existingPremium: false,
            orgMemId: null,
            amount: "",
          },
          ownerships: [],
          prizeId: -1,
        },
        async () => {
          const company = await companyApi.getCompany(this.state.user.companyId);
          const mainCode = company.codeTFF.find((c) => c.mainCode);

          this.setState({
            status: company[membership.toLowerCase() + "StatusName"],
            tffCodes: company.codeTFF,
            premium: {
              ...this.state.premium,
              reportedCodeTff: membership === "TFF" ? mainCode?.code || company.codeTFF[0]?.code : undefined,
            },
          });

          this.fetchMembersByOrg();
        }
      );
    }
  }

  fetchMembersByOrg = async () => {
    try {
      const members = await premiumUtils.fetchMembersByOrg(
        this.state.membership,
        this.state.user.companyId
      );

      if (members && members.length > 0) {
        const member = members[0];

        this.setState(
          {
            member,
            premium: {
              ...this.state.premium,
              orgMemId: member.orgMemId,
              prizeYear: new Date().getFullYear() - 1,
              amount: "",
            },
          },
          () => {
            if (this.state.premium.prizeYear) {
              this.fetchExistingPremium();
            } else {
              console.error("Premium Year is undefined!");
            }
          }
        );
      } else {
        console.error("No organization members found.");
        this.setState({
          member: {},
          premium: {
            orgMemId: null,
            prizeYear: "",
            amount: "",
            reportedCodeTff: "",
            existingPremium: false,
          },
        });
      }
    } catch (error) {
      console.error("Error in fetchMembersByOrg:", error);
      return null;
    }
  };

  fetchExistingPremium = async () => {
    try {
      const { membership, premium, user, tffCodes } = this.state;

      const result = await premiumUtils.fetchExistingPremium(
        membership,
        premium.prizeYear,
        user.companyId,
        membership === "TFF" ? premium.reportedCodeTff : undefined
      );

      if (result) {
        let { existingPremium, prizeId, existingAmount, ownerships, allPremiums } = result;

        const mainTffCode = tffCodes.find((c) => c.mainCode)?.code;

        if (membership === "TFF" && mainTffCode && Array.isArray(allPremiums)) {
          const updatedList = [...allPremiums];

          const legacyIndex = updatedList.findIndex(p => p.codeTFF === 0);
          const mainIndex = updatedList.findIndex(p => Number(p.codeTFF) === Number(mainTffCode));

          if (legacyIndex !== -1) {
            const legacy = updatedList[legacyIndex];
            const legacyAmount = Number(legacy.amount || 0);

            if (mainIndex !== -1) {
              updatedList[mainIndex] = {
                ...updatedList[mainIndex],
                amount: Number(updatedList[mainIndex].amount || 0) + legacyAmount,
              };
            } else {
              updatedList.push({ ...legacy, codeTFF: mainTffCode });
            }

            updatedList.splice(legacyIndex, 1);
            allPremiums = updatedList;

            if (!existingPremium) {
              const mergedPremium = updatedList.find(p => Number(p.codeTFF) === Number(mainTffCode));
              if (mergedPremium) {
                existingPremium = mergedPremium;
                existingAmount = mergedPremium.amount;
                prizeId = mergedPremium.prizeId;

                this.setState(prev => ({
                  premium: {
                    ...prev.premium,
                    reportedCodeTff: mainTffCode
                  }
                }));
              }
            }
          }
        }

        this.setState({
          premium: {
            ...premium,
            amount: existingAmount !== undefined && existingAmount !== null ? existingAmount : "",
            existingPremium: !!existingPremium,
          },
          ownerships: ownerships || [],
          prizeId: prizeId || -1,
          allPremiums: allPremiums || [],
        });
      }
    } catch (error) {
      console.error("Error in fetchExistingPremium:", error);
    }
  };

  onChange = async (e) => {
    const { name, value } = e.target;
    const { error, allPremiums, premium } = this.state;

    // Clear old errors
    const newError = { ...error, [name]: "" };
    const newPremium = { ...premium, [name]: value };

    // Handle codeTFF change
    if (name === "reportedCodeTff") {
      const matchingPremium = allPremiums.find(
        (p) => Number(p.codeTFF) === Number(value)
      );

      if (matchingPremium) {
        newPremium.amount = matchingPremium.amount;
        newPremium.prizeId = matchingPremium.prizeId;
        newPremium.existingPremium = true;
      } else {
        newPremium.amount = "";
        newPremium.prizeId = -1;
        newPremium.existingPremium = false;
      }
    }

    this.setState({ error: newError, premium: newPremium });
  };

  onSave = async (event) => {
    event.preventDefault();

    const { valid, error, newAmount } = premiumUtils.formIsValid(
      this.state.premium,
      "new"
    );
    await this.setState({ error });
    if (!valid) {
      return;
    }

    // eslint-disable-next-line react/no-direct-mutation-state
    this.state.premium.amount = newAmount;

    const premium = {
      ...this.state.premium,
      reportedCodeTff: parseInt(this.state.premium.reportedCodeTff, 10),
      amount: newAmount,
    };

    const savedPremium = await premiumUtils.savePremium(
      premium,
      "new"
    );
    if (savedPremium) {
      this.setState({
        ownerships: savedPremium.ownerships,
        prizeId: savedPremium.prizeId,
      });
      await this.fetchExistingPremium();
    } else {
      console.log("Save operation failed.");
    }
  };

  handleTransferPremium = async (prizeId) => {
    const targetCode = this.state.selectedTffCode[prizeId];
    if (!targetCode) {
      console.warn("Ingen TFF-kode valgt for overføring.");
      return;
    }

    const success = await premiumUtils.transferPremiumToCodeAndHandle(prizeId, this.state.premium.prizeYear, targetCode);

    if (success) {
      await this.fetchExistingPremium();
    }
  };

  render() {
    const root = {
      width: "100%",
    };

    const layout = {
      width: "100%",
      paddingTop: 80,
    };

    const paper = {
      paddingLeft: 30,
      paddingTop: 20,
      paddingRight: 30,
      paddingBottom: 50,
    };

    const gridPaddingTop = {
      paddingTop: 20,
    };

    const head = {
      backgroundColor: "#eeeeee",
      fontWeight: "bold",
      fontSize: 16,
      textDecoration: "none",
    };

    const formcontrolselect = {
      minWidth: "100%",
    };

    const emptyPaper = {
      textAlign: "center",
      paddingLeft: 250,
    };

    const smallLabelStyle = {
      fontSize: "12px",
      color: "rgba(0, 0, 0, 0.6)",
    };

    const NOKPrefix = (
      <span
        style={{
          fontSize: "16px",
        }}
      >
        NOK
      </span>
    );

    return (
      <Container maxWidth="lg" sx={{ ml: 0 }}>
        <form onSubmit={this.onSave} >
          <main style={layout} >
            <Paper style={paper}>
              <React.Fragment>
                <CssBaseline />
                <Grid container spacing={4}>
                  <Grid item lg={5}>
                    <h2>
                      {this.state.premium.existingPremium
                        ? "Oppdater"
                        : "Ny"}{" "}
                      {this.state.membership === "TFF" ? "TFF" : "YFF"}-premie
                    </h2>
                    <Grid>
                      <FormControl style={formcontrolselect}>
                        <TextField
                          name="orgMemId"
                          label={`${this.state.membership === "TFF" ? "TFF" : "YFF"
                            } Medlem`}
                          value={
                            this.state.member.companyName
                              ? `${this.state.member.companyName} (${this.props.type})`
                              : ""
                          }
                          fullWidth
                          variant="standard"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Typography style={{ color: "red" }}>
                      {this.state.error.orgMemId}
                    </Typography>

                    {this.state.membership === "TFF" && (
                      <Grid style={gridPaddingTop}>
                        <FormControl style={formcontrolselect} fullWidth>
                          {this.state.tffCodes.length === 1 ? (
                            <TextField
                              name="reportedCodeTff"
                              label="TFF Kode"
                              value={this.state.tffCodes[0]?.code || ""}
                              fullWidth
                              variant="standard"
                              InputProps={{
                                readOnly: true,
                              }}
                            />
                          ) : (
                            <TextField
                              select
                              name="reportedCodeTff"
                              label="TFF Kode"
                              value={this.state.premium.reportedCodeTff || (this.state.tffCodes[0]?.code || "")}
                              onChange={this.onChange}
                              fullWidth
                              variant="standard"
                              SelectProps={{
                                native: true,
                              }}
                            >
                              {this.state.tffCodes.map((codeObj) => (
                                <option key={codeObj.code} value={codeObj.code}>
                                  {codeObj.code} {codeObj.mainCode ? "(Hovedkode)" : ""}
                                </option>
                              ))}
                            </TextField>
                          )}
                        </FormControl>
                        {(() => {
                          const mainCodeCount = this.state.tffCodes.filter(c => c.mainCode).length;

                          if (mainCodeCount > 1) {
                            return (
                              <Typography variant="body2" color="error" style={{ paddingTop: 8 }}>
                                Mer enn én hovedkode registrert, handling kreves
                              </Typography>
                            );
                          }

                          if (mainCodeCount === 0 && this.state.tffCodes.length > 0) {
                            return (
                              <Typography variant="body2" color="error" style={{ paddingTop: 8 }}>
                                Ingen hovedkode registrert, handling kreves
                              </Typography>
                            );
                          }

                          return null;
                        })()}
                        <FormHelperText>Velg TFF kode å registrere premie for</FormHelperText>
                      </Grid>
                    )}

                    <Grid style={gridPaddingTop}>
                      <FormControl style={formcontrolselect}>
                        <TextField
                          name="prizeYear"
                          label="År"
                          value={this.state.premium.prizeYear || ""}
                          fullWidth
                          variant="standard"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      </FormControl>
                    </Grid>
                    <Typography style={{ color: "red" }}>
                      {this.state.error.prizeYear}
                    </Typography>

                    <Grid item style={gridPaddingTop}>
                      <FormControl fullWidth className="MuiFormControl-root MuiTextField-root">
                        <Typography variant="caption" style={smallLabelStyle}>
                          Opptjent premie
                        </Typography>
                        <div
                          className={`MuiInputBase-root MuiInput-root MuiInput-underline MuiInputBase-fullWidth MuiInput-fullWidth MuiInputBase-formControl MuiInput-formControl ${!this.state.isActive(this.state.status)
                            ? "Mui-disabled"
                            : ""
                            }`}
                        >
                          <CurrencyInput
                            ref={this.currencyInputRef}
                            name="amount"
                            InputProps={{
                              startAdornment: this.state.isActive(this.state.status) ? (
                                <InputAdornment position="start">{NOKPrefix}</InputAdornment>
                              ) : null
                            }}
                            placeholder={
                              !this.state.isActive(this.state.status)
                                ? `Bedriften er ikke aktivt ${this.state.membership === "TFF"
                                  ? "TFF"
                                  : "YFF"
                                } medlem`
                                : ""
                            }
                            className={`MuiInputBase-input MuiInput-input ${!this.state.isActive(this.state.status)
                              ? "Mui-disabled"
                              : ""
                              }`}
                            type="text"
                            value={
                              this.state.premium.amount !== undefined && this.state.premium.amount !== null
                                ? String(this.state.premium.amount)
                                : ""
                            }
                            onChange={this.onChange}
                            disabled={!this.state.isActive(this.state.status)}
                            style={{
                              position: "relative",
                              top: "1px",
                            }}
                          />
                        </div>
                      </FormControl>
                      <FormHelperText>
                        {`Opptjent premie i ${this.state.premium.prizeYear || "foregående år"
                          } for lovpålagt ${this.state.membership === "TFF"
                            ? "trafikkforsikring"
                            : "yrkesskadeforsikring"
                          } (i hele norske kroner). Direkte norsk forretning uten fradrag av reassuranse${this.state.membership === "TFF" ? " og uten TFA" : ""
                          }.`}
                      </FormHelperText>
                      <Typography style={{ color: "red" }}>
                        {this.state.error.amount}
                      </Typography>
                    </Grid>

                    <Grid style={{ paddingTop: 40 }}>
                      <Button
                        startIcon={<SaveIcon />}
                        type="submit"
                        variant="contained"
                        color="primary"
                      >
                        {"Lagre"}
                      </Button>
                      <React.Fragment>
                        <br />
                      </React.Fragment>
                    </Grid>
                  </Grid>

                  <Grid item lg={7}>
                    <h2>Opprinnelse og eierskap</h2>
                    <div style={gridPaddingTop}>
                      <Paper style={root}>
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow>
                              <TableCell key="ownedByCompanyName" style={head}>
                                Navn
                              </TableCell>
                              <TableCell key="fromDate" style={head}>
                                Fra
                              </TableCell>
                              <TableCell key="toDate" style={head}>
                                Til
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.ownerships &&
                              this.state.ownerships.length > 0 ? (
                              this.state.ownerships.map(
                                (ownership, index) => {
                                  const formatDate = (dateString) => {
                                    if (!dateString) return "";
                                    const date = new Date(dateString);
                                    const day = String(date.getDate()).padStart(2, "0");
                                    const month = String(date.getMonth() + 1).padStart(2, "0");
                                    const year = date.getFullYear();
                                    return `${day}.${month}.${year}`;
                                  };

                                  const fromDate = formatDate(ownership.fromDate);
                                  const toDate = formatDate(ownership.toDate);
                                  return (
                                    <TableRow
                                      hover
                                      tabIndex={-1}
                                      key={index}
                                    >
                                      <TableCell>
                                        {ownership.ownedByCompanyName}
                                      </TableCell>
                                      <TableCell>{fromDate}</TableCell>
                                      <TableCell>{toDate}</TableCell>
                                    </TableRow>
                                  );
                                }
                              )
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  <Typography style={emptyPaper}>
                                    Ingen eierskap
                                  </Typography>
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </Paper>
                    </div>
                  </Grid>

                  {this.state.membership === "TFF" && (
                    <Grid item xs={12} style={gridPaddingTop}>
                      <h2>Tidligere registrerte premier</h2>
                      <Paper style={root}>
                        <Table stickyHeader aria-label="registered premiums table">
                          <TableHead>
                            <TableRow>
                              <TableCell style={head}>Rapportert av</TableCell>
                              <TableCell style={head}>TFF Kode</TableCell>
                              <TableCell style={head}>Handling</TableCell>
                              <TableCell style={head}>År</TableCell>
                              <TableCell style={head}>Beløp (NOK)</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.allPremiums && this.state.allPremiums.length > 0 ? (

                              <>
                                {/* Total row */}
                                <TableRow>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    Total sum registrert for Risikobærer
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    -----
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    -----
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    {this.state.premium.prizeYear}
                                  </TableCell>
                                  <TableCell style={{ fontWeight: "bold" }}>
                                    {this.state.allPremiums
                                      .filter(p => typeof p.amount === "number" && p.amount >= 0)
                                      .reduce((sum, p) => sum + p.amount, 0)
                                      .toLocaleString("nb-NO")}
                                  </TableCell>
                                </TableRow>

                                {/* Individual premium rows */}
                                {[...this.state.allPremiums]
                                  .sort((a, b) => Number(a.codeTFF) - Number(b.codeTFF))
                                  .map((p) => {
                                    const availableCodes = this.state.tffCodes.filter(
                                      (codeObj) => Number(codeObj.code) !== Number(p.codeTFF)
                                    );

                                    return (
                                      <TableRow key={p.prizeId}>
                                        <TableCell>{p.reportedByCompanyName}</TableCell>
                                        <TableCell>
                                          {p.codeTFF}
                                          {this.state.tffCodes.find(
                                            (c) => Number(c.code) === Number(p.codeTFF) && c.mainCode
                                          )
                                            ? " (Hovedkode)"
                                            : ""}
                                        </TableCell>
                                        <TableCell>
                                          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                                            <Select
                                              value={this.state.selectedTffCode[p.prizeId] ?? ""}
                                              onChange={(e) => {
                                                const selectedValue = e.target.value;
                                                this.setState((prev) => ({
                                                  selectedTffCode: {
                                                    ...prev.selectedTffCode,
                                                    [p.prizeId]: selectedValue,
                                                  },
                                                }));
                                              }}
                                              displayEmpty
                                              variant="standard"
                                              native
                                              disabled={availableCodes.length === 0}
                                              style={{ minWidth: "100px" }}
                                            >
                                              <option value="">Velg kode</option>
                                              {availableCodes.map((codeObj) => (
                                                <option key={codeObj.code} value={codeObj.code}>
                                                  {codeObj.code} {codeObj.mainCode ? "(Hovedkode)" : ""}
                                                </option>
                                              ))}
                                            </Select>
                                            <Button
                                              variant="contained"
                                              color="primary"
                                              size="small"
                                              onClick={() => this.handleTransferPremium(p.prizeId)}
                                              disabled={
                                                availableCodes.length === 0 || !this.state.selectedTffCode[p.prizeId]
                                              }
                                            >
                                              Overfør
                                            </Button>
                                          </div>
                                        </TableCell>
                                        <TableCell>{p.prizeYear}</TableCell>
                                        <TableCell>{Number(p.amount).toLocaleString("nb-NO")}</TableCell>
                                      </TableRow>
                                    );
                                  })}
                              </>
                            ) : (
                              <TableRow>
                                <TableCell colSpan={4} align="center">
                                  Ingen registrerte premier for denne perioden
                                </TableCell>
                              </TableRow>
                            )}
                          </TableBody>
                        </Table>
                      </Paper>
                    </Grid>
                  )}

                </Grid>
              </React.Fragment>
            </Paper>
          </main>
        </form>
      </Container>
    );
  }
}

function mapStateToProps(state) {
  const signedinuser = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : sessionStorage.getItem("token")
      ? JSON.parse(sessionStorage.getItem("token"))
      : [];

  return { signedinuser: signedinuser };
}

export default connect(mapStateToProps)(NewPremiumUser);
